import EditIcon from "@mui/icons-material/Edit";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { ChangeEvent, useState } from "react";
import { useDataGridSettings } from "../DataGridSettingsProvider";
import { DiagnosticSettingsSlotProps } from "@/models/CustomColumnMenuProps";

export default function RenameColumnMenuItem(props: DiagnosticSettingsSlotProps) {
  const { field, colDef } = props;
  const { headerName } = colDef;
  const { columnNames, setColumnNames } = useDataGridSettings();
  const [value, setValue] = useState(columnNames[field] ?? headerName);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value);
  };

  const handleBlur = () => {
    setColumnNames(prev => ({ ...prev, [field]: value }));
  };

  return (
    <MenuItem>
      <ListItemIcon>
        <EditIcon />
      </ListItemIcon>
      <Tooltip title={value}>
        <TextField
          placeholder={headerName}
          value={value ?? ""}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={e => e.stopPropagation()}
        />
      </Tooltip>
    </MenuItem>
  );
}
